module.exports = __webpack_public_path__ + "static/media/01.d878fc31.wav";